import React, { useEffect } from 'react';
import './styles/hide-clear-buttons.css';

/**
 * GlobalFixes - Component to apply global fixes for styling and behavior issues
 * This component doesn't render anything visible but applies fixes through CSS and JS
 */
const GlobalFixes = () => {
  useEffect(() => {
    console.log("GlobalFixes mounted - applying fixes");
    
    // Function to fix MUI TextField tab behavior
    const fixMUITabbing = () => {
      // STEP 1: Make all wrapper elements non-tabbable
      const wrappers = document.querySelectorAll(
        '.MuiFormControl-root, .MuiInputBase-root, .MuiOutlinedInput-root, .MuiInputLabel-root, ' +
        '[class*="-container"], [class*="-wrapper"]'
      );
      
      wrappers.forEach(wrapper => {
        wrapper.setAttribute('tabindex', '-1');
      });
      
      // STEP 2: Target ALL form inputs to make them tabbable
      const allInputs = document.querySelectorAll('input, textarea, select');
      allInputs.forEach(input => {
        if (!input.disabled && input.type !== 'hidden') {
          input.tabIndex = 0;
        }
      });
      
      // STEP 3: Specifically target number fields
      const numericFields = document.querySelectorAll(
        'input[type="number"], ' +
        '.tag-decimal-field-editable-container input, ' +
        '.tag-number-field-editable-container input, ' +
        '.decimal-text-field input, ' +
        '.tag-number-field-input input'
      );
      
      numericFields.forEach(input => {
        // Force tabIndex to be 0
        input.tabIndex = 0;
      
        // Ensure parent elements don't trap focus
        let parent = input;
        for (let i = 0; i < 5; i++) { // Check up to 5 levels up
          parent = parent.parentElement;
          if (parent) {
            parent.tabIndex = -1;
          } else {
            break;
          }
        }
      });
      
      // STEP 4: Adjust grid layouts
      // First, find all grid items that are meant to contain inputs
      const inputContainers = document.querySelectorAll(
        '.tag-textfield-editable-item, ' +
        '.tag-memo-fields-input, ' +
        '.text-field-container, ' +
        '.tag-textfield-editable-container > .MuiGrid-item:first-child, ' +
        '.tag-decimal-field-editable-container > .MuiGrid-item:first-child, ' +
        '.tag-number-field-editable-container > .MuiGrid-item:first-child'
      );
      
      // Make them full width
      inputContainers.forEach(container => {
        container.style.flexBasis = '100%';
        container.style.maxWidth = '100%';
        container.style.width = '100%';
      });
      
      // Find all grid containers that likely have a clear button
      const gridContainers = document.querySelectorAll(
        '.tag-textfield-editable-container, ' +
        '.tag-decimal-field-editable-container, ' +
        '.tag-number-field-editable-container, ' +
        '.tag-memo-fields-container'
      );
      
      // For each container, hide the second child (which is likely the clear button)
      gridContainers.forEach(container => {
        const children = container.children;
        if (children.length > 1) {
          for (let i = 1; i < children.length; i++) {
            children[i].style.display = 'none';
          }
        }
      });
    };

    // Apply the tab fixes immediately
    fixMUITabbing();
    
    // Also apply tab fixes periodically to catch dynamically added elements
    const tabInterval = setInterval(fixMUITabbing, 2000);
    
    // Apply CSS styles
    const style = document.createElement('style');
    style.innerHTML = `...`;
    document.head.appendChild(style);

    // Clean up on unmount
    return () => {
      clearInterval(tabInterval);
      document.head.removeChild(style);
    };
  }, []);

  return null;
};

export default GlobalFixes;